export enum RoutingStep {
  CLOSED = 0,
  FORM = 1,
  MODE_SELECT = 2,
  RESULTS = 3,
  RESULT_DETAILS = 4,
}
